import React from 'react';
import { Route } from 'react-router-dom';

import logo from 'assets/white-logo.svg';
import Notify from 'components/ui/Notify';

const ModalLayout = ({component: Component, links, footer, ...rest}) => {
  return (
    <div>
      <div className="ModalLayout">
        <div className="ModalLayout__logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="ModalLayout__content">
          <Route {...rest} render={matchProps => (
            <Component {...matchProps} />
          )} />
        </div>
        <div className="ModalLayout__links">
          {links.map((link, i) =><div key={i}>{link}</div>)}
        </div>

        {footer}
      </div>
      <Notify time={5} />
    </div>

  )
}

export default ModalLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/ModalLayout/ModalLayout.js